export default "__VITE_ASSET__40rvRn4V__"